var DatePicker = function () {
    var currentContext = $(document);
    var moduleOptions = {
        defaultDate: "+1w",
        changeMonth: true,
        changeYear: true,
        dateFormat: "d/M/yy",
        showButtonPanel: true,
        closeText: "Clear",
        beforeShow: function (input) {
            setTimeout(function () {
                $(input).datepicker("widget").find(".ui-datepicker-close").unbind("click").bind("click", function () {
                    $.datepicker._clearDate(input);
                });
            }, 1);
        }
    };

    this.init = function (context, options) {
        currentContext = context || currentContext;
        $.extend(moduleOptions, options);

        currentContext.datepicker(moduleOptions);

        var value = currentContext.val();
        if (value) {
            var date = null;
            try {
                date = new Date(value);
            }
            catch(e) {
                //ignore
            }
            if (date) {
                currentContext.datepicker("setDate", date);
            }
        }
    };
};

module.exports = DatePicker;